/**
 * Shared design tokens for the IR Copilot experience.
 *
 * This module is presentation-only: a single source of truth for color,
 * spacing, radius, typography and elevation so the chat pane, the draft
 * preview pane and the drawer chrome read as one coherent product instead
 * of three independently-styled pieces.
 *
 * No logic, no dependencies. Import what you need.
 */

export const C = {
	// Structural / neutral
	ink: "#0f172a", // primary text
	inkSoft: "#475569", // secondary text
	inkFaint: "#94a3b8", // tertiary text / meta
	line: "#e2e8f0", // borders
	lineSoft: "#eef2f7", // hairline dividers
	surface: "#ffffff", // cards, bubbles
	surfaceMuted: "#f8fafc", // page / panel background
	surfaceSunken: "#f1f5f9", // input wells, message list bg

	// Single calm accent (steel blue) — used sparingly
	accent: "#2563eb",
	accentHover: "#1d4ed8",
	accentSoft: "#eff4ff",
	accentLine: "#c7d7fe",

	// Status (kept muted, enterprise-appropriate)
	ok: "#16a34a",
	okSoft: "#f0fdf4",
	okLine: "#bbf7d0",
	warn: "#d97706",
	warnSoft: "#fffbeb",
	warnLine: "#fde68a",
	danger: "#dc2626",
};

// 4px rhythm
export const S = {
	xs: 4,
	sm: 8,
	md: 12,
	lg: 16,
	xl: 20,
	xxl: 24,
};

export const R = {
	sm: 6,
	md: 8,
	lg: 10,
	pill: 999,
};

// Two restrained elevation levels only — borders do the structural work.
export const E = {
	low: "0 1px 2px rgba(15,23,42,0.04)",
	mid: "0 4px 16px rgba(15,23,42,0.06)",
};

export const T = {
	meta: 11,
	small: 12,
	body: 13,
	bodyLg: 14,
};